import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/i18n";
import App from "@/App";
import { maybeRedirectForLocale } from "@/lib/activeLang";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

if (new URLSearchParams(window.location.search).has("embed")) document.documentElement.classList.add("embed");

const root = ReactDOM.createRoot(document.getElementById("root"));
if (!maybeRedirectForLocale()) {
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>,
  );
}
